export type LocaleMessages = Record<string, string | Record<string, string>>;

export const ur_PK_messages: LocaleMessages = {
    loading: "ابتداء",

    site: {
        title: "قلم",
        description: "لکھو، پڑھو اور علم بانٹو",
    },

    contact: {
        facebook: "فیس بُک",
        description:
            "آپ باآسانی فیس بُک پر ہم سے رابطہ کر سکتے ہیں. ہمارے پیج کو پسند کیجئے اور دوسروں تک اس پیغام کو پہنچائے.",
    },

    topMenu: {
        facebook: "فیس بُک",
        help: "مدد",
        contact: "رابطہ",
        homepage: "صفحہ اؤل",
        copyrights: "کاپی رائٹ",
        terms: "اصول",
    },

    book: {
        read: "کتاب پڑھیں",
        shareOnFacebook: "فیس بُک پر شیئر کرو",
        shareWithFriends: "دوستوں کے ساتھ شئیر کریں",
    },

    featured: {
        weight: "وزن",
        tagTitle: "نمایاں",
    },

    header: {
        loginRegister: "لاگن / رجسٹریشن",
        account: "اکاؤنٹ",
        writeBook: "کتاب لِکھو",
        docs: "دستاویزات",
    },

    results: {
        loadMore: "مزید لوڈ کریں",
        none: "اس تلاش کے کوئی نتائج برآمد نہیں ہوئے",
        tagsNone: "اس ٹیگ کے ساتھ کوئی بھی نتائجہ منسلک نہیں ہے",
    },

    doc: {
        heading: "ڈاکیومنٹ",
        title: "عنوان",
        access: "رسائی",
        public: "عوامی",
        private: "ذاتی",
        created: "دستاویز کامیابی کے ساتھ تخلیق پا گئی.",
        saved: "دستاویز کامیابی کے ساتھ محفوظ کر لی گئی.",
        failed: "دستاویز محفوظ کرنے میں ناکامی.",
        passwordProtected: "محفوظ بمعہ پاسورڈ",
        new: "نئ دستاویز",
        preview: "پیش نظر",
        edit: "معلومات بدلو",
        editDoc: "دستاویز ایڈیٹر",
        save: "محفوظ کریں",
        cancel: "منسوخ کریں",
        remove: "حذف کرو",
        meta: "خصوصیات",
        confirmRemove: "کیا آپ واقعی دستاویز کو حذف کرنا چاہتے ہیں؟",
        confirmRemoveAll: "کیا آپ واقعی تمام دستاویزات کو حذف کرنا چاہتے ہیں؟",
        search: "دستاویزات فلٹر کریں",
    },

    pageForm: {
        titleCreate: "نیا صفحہ",
        titleEdit: "صفحہ میں ترمیم",
        created: "نیا صفحہ کامیابی سے تخلیق ہو گیا.",
        saved: "صفحہ کامیابی محفوظ کر لیا گیا.",
        failed: "معلومات محفوظ کرنے میں ناکامی.",
        new: "نیا صفحہ",
        edit: "معلومات بدلو",
        save: "محفوظ کریں",
        cancel: "منسوخ کریں",
        remove: "حذف کرو",
        confirmRemove: "کیا آپ واقعی صفحہ کو حذف کرنا چاہتے ہیں؟",
        confirmRemoveAll: "کیا آپ واقعی اِن تمام صفحات کو حذف کرنا چاہتے ہیں؟",
        onlyPageCannotDelete:
            "اس دستاویز میں صرف ایک صفحہ ہے، اگر آپ اس صفحہ کو حزف کرنا چاہتے ہیں تو تمام دستویز کو حذف کیجئے.",
        name: "نام",
        status: "حالت",
        parent_id: "احاطی صفحہ",
        statusDRAFT: "مسودہ",
        statusPUBLISHED: "شائع",
        pageStatusInvalid: "مسودے کے لیے صیح آپشن کا انتخاب کیجئے",
        submitBtnCreate: "تخلیق کرو",
        submitBtnEdit: "محفوظ کرو",
        alternateBtnCreate: "واپس",
        alternateBtnEdit: "واپس",
    },

    confirm: {
        yes: "ہاں",
        no: "نہیں",
    },

    user: {
        add: "ممبر شامل کریں",
        name: "نام",
        status: "حیثیت",
    },

    userDocForm: {
        titleCreate: "ممبر شامل کریں",
        submitBtnCreate: "محفوظ کرو",
        titleEdit: "ممبرشپ میں ترمیم",
        alternateBtnCreate: "واپس",
        submitBtnEdit: "محفوظ کرو",
        alternateBtnEdit: "واپس",
        added:
            "ممبر کامیابی کے ساتھ شامل. اگلی مرتبہ ممبر لاگن کر کے دستویزات میں اس دستاویز کو دیکھ سکے گا.",
        alreadyAMember: "ممبر پہلے سے دستاویز میں شامل ہے.",
        saved: "ممبر میں تبدیلی کامیابی کے ساتھ طے پا گئی.",
        failed: "ممبر میں تبدیلی میں ناکامی.",
        email: "اِی میل",
        statusEDITOR: "ایڈیٹر",
        statusAUTHOR: "مصنف",
        statusREVIEWER: "جائزہ کار",
        statusREADER: "پروف ریڈر",
        edit: "معلومات بدلو",
        cancel: "منسوخ کریں",
        remove: "حذف کرو",
        confirmRemove: "کیا آپ واقعی ممبر کو حذف کرنا چاہتے ہیں؟",
        confirmRemoveAll: "کیا آپ واقعی اِن تمام ممبرز کو حذف کرنا چاہتے ہیں؟",
    },

    tools: {
        format: "فارمیٹ",
        insert: "انسرٹ",
        design: "ڈزائین",
        layout: "لے آوٹ",
        collaboration: "اشتراک",
    },

    lang: {
        eng: "انگریزی",
        urd: "اُردو",
    },

    layout: {
        toc: "فہرست",
        margins: "کنارے",
        orientation: "سمت",
        size: "ناپ",
        colors: "رنگ",
        newPage: "نیا صفحہ",
    },

    editor: {},

    editorMenu: {
        pages: "صفحات",
        users: "ممبران",
        toggleTheme: "رنگ بدلو",
        translate: "ترجمہ",
        export: "ایکسپورٹ",
        docs: "دستاویزات",
        addPage: "نیا اضافحہ",
    },

    rsb: {
        width: "چوڑائی",
        width_inch: "چوڑائی (انچ)",
        height: "اونچائی",
        height_inch: "اونچائی (انچ)",
    },

    rsbSizes: {
        letter: "خط",
        tabloid: "اخبار",
        legal: "قانونی",
        statement: "بیان",
        executive: "ایگزیکٹو",
        a3: "اے۳",
        a4: "اے۴",
        a5: "اے۵",
        b4: "بی۴",
        b5: "بی۵",
    },

    footer: {
        words: "الفظ",
    },

    foreground: "پیش منظر",
    background: "پس منظر",

    menu: {
        login: "لاگ اِن",
        logout: "لاگ آوٹ",
        account: "اکاؤنٹ",
        docs: "دستاویزات",
        vision: "سوچ",
        use: "استمال",
        contact: "رابطہ",
    },

    tab: {
        loginForm: "لاگن",
        registerForm: "رجسٹریشن",
        resetPasswordForm: "پاسورڈ بھولنا",
    },

    loginForm: {
        title: "لاگ اِن",
        email: "اِی میل",
        password: "پاسورڈ",
        submitBtn: "لاگ اِن",
        failed: "براہ کرم آپ کا دیا ہو ای میل یا پاسورڈ درست نہیں.",
    },

    onBoarding: {
        next: "اگلا قدم",
        startEditor: "لوڈ کرو",
    },

    registerForm: {
        title: "رجسٹریشن",
        name: "نام",
        email: "اِی میل",
        password: "پاسورڈ",
        confirmPassword: " پاسورڈ دہرایں",
        submitBtn: "داخلہ",
        success:
            "رجسٹریشن میں کامیابی، اپنا میل چیک کر کے اکاؤنٹ چالو کریں. میل گمشدگی کی صورت میں سپیم باکس چیک کرنا مت بھولیے گا.",
        failure: "اس ای میل کا اکاؤنٹ پہلے سے رجسٹرڈ ہے.",
    },

    editProfileForm: {
        title: "اکاؤنٹ",
        name: "نام",
        email: "اِی میل",
        password: "نیا پاسورڈ",
        confirmPassword: "نیا پاسورڈ دہرایں",
        submitBtn: "محفوظ کرو",
        alternateBtn: "منسوخ کرو",
    },

    resetPasswordForm: {
        title: "پاسورڈ بھولنا",
        email: "موجودہ اِی میل",
        submitBtn: "کوشش کرو",
        failed:
            "براہ مہربانی، اِی میل پر نظر ڈالیے اس اِی میل سے ہمارے نظام میں کوئی نہیں.",
        success:
            "اپنا ای میل چیک کیجئے، ایک نیا پاسورڈ آپ کو ارسال کر دیا گیا ہے.",
    },

    createDocForm: {},

    editDocForm: {
        title: "دستاویز میں ترمیم",
    },

    docForm: {
        titleCreate: "نئ دستاویز",
        titleEdit: "دستاویز میں ترمیم",
        submitBtnCreate: "تخلیق کرو",
        submitBtnEdit: "محفوظ کرو",
        alternateBtnCreate: "واپس",
        alternateBtnEdit: "واپس",
        name: "نام",
        status: "حالت",
        statusDRAFT: "مسودہ",
        statusPUBLISHED: "شائع",
        lastUpdated: "تاریخ",
        visibility: "نمائش",
        visibilityPUBLIC: "عوامی",
        visibilityPRIVATE: "ذاتی",
        docStatusInvalid: "مسودے کے لیے صیح آپشن کا انتخاب کیجئے",
        docVisibilityInvalid: "نمائش کے لیے صیح آپشن کا انتخاب کیجئے",
        created: "دستاویز کامیابی کے ساتھ بنائی جا چکی ہے",
        saved: "دستاویز میں ترمیم کامیابی کے ساتھ محفوظ.",
        failed: "دستاویز میں ترمیم میں ناکامی.",
    },

    docMetaForm: {
        titleEdit: "خصوصیات",
        authors: "مصنف . ایک سے زیادہ کو ؛ سے الگ کرو",
        intro: "تعارف",
        tags: "ٹیگز",
        cover: "سرورق سائز png 794x1122 ہو جو زیادہ سے زیادہ 1 MB",
        submitBtnEdit: "محفوظ کرو",
        alternateBtnEdit: "واپس",
        saved: "معالومات کو کامیابی کے ساتھ محفوظ کر لیا گیا.",
    },

    createPageForm: {
        title: "نیا صفحہ",
        saveBtn: "تخلیق کرو",
    },

    editPageForm: {
        title: "صفحہ میں ترمیم",
    },

    form: {
        selectEmptyLabel: "❊",
        nameRequired: "نام فرام کیجئے.",
        nameMinChars: "نام کم سے کم ۳ حروف پر مشتمل ہونا چاہیے.",
        authorsMinChars: "مصنف کم سے کم ۳ حروف پر مشتمل ہونا چاہیے.",
        introMinChars: "تعارف فراہم کیجئے.",
        emailRequired: "اِئ میل فرام کیجئے.",
        emailInvalid: "درست اِئ میل فراہم کیجئے.",
        passwordRequired: "پاسورڈ فرام کیجئے.",
        passwordMinChars: "پاسورڈ کم سے کم ۶ حروف پر مشتمل ہونا چاہیے.",
        confirmPasswordRequired: "پاسورڈ فرام کیجئے.",
        confirmPasswordSameAsPassword:
            "دہرایا ہوا پاسورڈ اور پاسورڈ ایک جیسا ہونا چاہیے.",
        emailAlreadyRegistered:
            "اس اِی میل پہلے سے رجسٹرڈ ہے. آپ اس سے لاگ اِن کیجیے یا پاسورڈ بھولنے کے صورت میں پاسورڈ بھولنا میں جا کر تلاش کریں.",
        introRequired: "تعارف فرام کیجئے.",
        authorsRequired: "مصنف فرام کیجئے.",
        tagsRequired: "ٹیگز فرام کیجئے.",
        tagsCount_1_3: "۱ سے ۳ کی حد تک ٹیگز چن سکتے ہیں.",
        invalidLogin:
            "غلط لاگن، براہ مہربانی صحیح اِی میل اور پاسورڈ فراہم کیجئے.",
        validLogin: "لاگ اِن میں کامیابی.",
        saved: "کامیابی کے ساتھ محفوظ.",
        return: "واپس",
        date: "تاریخ",
        saveBtn: "محفوظ کرو",
        unmodified: "معلومات میں کوئی تبدیلی واقع نہیں ہوئی.",
    },

    copy: {
        translation: "ترجمعہ کاپی کرو",
    },

    export: {
        title: "ایکسپورٹ",
        pdf: "پی.ڈی.اِیف",
        epub: "اِی پَب",
        mobi: "موبی",
        return: "واپس",
    },

    market: {
        title: "بازار",
    },

    toolbar: {
        linkPlaceholder: "یہاں لنک درج کیجئے",
        uploadingImage: "تصویر اَپلوڈ ہو رہی ہے",
        maxImageSizeError:
            "آپ کو ۱ایم.بی سے بڑی تصویر اپلوڈ کرنے کی اجازت نہیں",
    },

    resize: {
        width: "چوڑائی :",
        height: "اونچائی :",
    },

    tip: {
        share: "فیسبُک پر شیئر",
        theme: "رنگ بدلو",
        size: "سائز بدلو",
        return: "واپس",
        toc: "فہرست",
        download: "ڈاؤنلوڈ",
    },

    translate: {
        title: "ترجمہ",
        description: "ایک زبان سے دوسری زبان میں متن کا ترجمہ کریں.",
    },

    merge: {
        title: "ضم",
        description:
            "اس صفحہ میں آپ اپنے کام کو دوسروں کے کام میں شامل کر سکتے ہیں.",
        src: "منتخب کریں، صفحہ جس میں آپ نے تبدیلیاں کی ہیں",
        srcAll: "منتخب کریں، صفحہ جس سے آپ نے تبدیلیاں لینی ہیں",
        dst: "منتخب کریں، صفحہ جس میں آپ کی تبدیلیاں ضم ہوں",
        confirmRequest: "ہاں، میں اسے ضم کرنے کی درخواست کرتا ہوں",
        alreadyUpToDate: "اِس صفحہ کے مقابلہ میں کوئی تبدیلی دستیاب نہیں.",
        compareDescription: "اُوپر سے بلمقابل صفحات کا انتخاب کریں.",
        split: "تقسیم",
        unified: "متحد",
        requestCreated: "آپ کی درخواست کامیابی سے بھیج دی گئی ہے.",
        noChanges: "صفحات کے بلمقابل کوئی تبدیلی دستیاب نہیں.",
        titleRequest: "درخواستیں",
        requestDescription:
            "دوسرے لوگ آپ کے کام میں مدد کے لیے جو کام کریں، اُس کی وہ درخواست بنائیں گئے جو آپ یہاں دیکھ سکیں گئے. یہ آپ پر منحصر ہے کہ آپ اُن کا کام قبول کریں یا رد کر دیں.",
        number: "نمبر",
        status: "حالت",
        OPEN: "سوالیہ",
        PENDING: "زیر غور",
        REJECTED: "مسترد",
        RESOLVED: "حل شدہ",
        src_name: "مطلوب",
        dst_name: "ذمہ دار",
        page_name: "صفحہ",
        resolveTitle: "ضم کا فیصلہ",
        resolveDescription:
            "یہاں آپ فیصلہ کر سکتے ہیں، اگر آپ تبدیلیوں کو قبول کرنا چاہتے ہیں یا نہیں.",
        confirmMerge: "ہاں. میں اِن تبدیلیوں کو قبول کرتا ہوں",
        cancelMerge: "نہیں، اِسے رد کریں",
        accepted:
            "آپ نے تبدیلیوں کو کامیابی کہ ساتھ اپنے صفحہ میں شامل کر دیا ہے.",
        rejected:
            "ان تبدیلیوں کو زائل کر دیا گیا ہے. اگر درخواست کندہ کو اِس صفحہ میں تبدیلیاں مطلوب ہوں تو نئ درخواست دائر کریں.",
        alreadyRejected:
            "یہ درخواست پہلے ہی مسترد کی جا چکی ہے. اگر درخواست کندہ کو اِس صفحہ میں تبدیلیاں مطلوب ہوں تو نئ درخواست دائر کریں.",
        alreadyResolved: "یہ درخواست پہلے ہی آپ کے صفحہ کا حصہ بن چکی ہے.",
        bothAreEqual: "یہ صفحات ہر طرح سے ایک جیسے ہیں.",
        present: "حال",
        future: "مسقتبل",
        all: "تمام",
    },
};
